import { Container } from "pixi.js";

import { AbstractDisplayComponent } from "../../core/displays/AbstractDisplayComponent";
import { RIPTypeTrigger } from "./RIPTypeTrigger";



export class RIPTypeTriggerComponent extends AbstractDisplayComponent {
    private container: Container;

    public override init() {
        let containerConfig = {
            labelName: "riptrigger_container",
            anchorX: 0.5,
            anchorY: 0.5,
            landscape: {
                posX: 1024,
                posY: 1024,
                scale: 1,
            },
            portrait: {
                posX: 1024,
                posY: 1024,
                scale: 1.2,
            }
        };

        this.container = new RIPTypeTrigger(containerConfig);
    }

    public getInstance(): Container {
        return this.container;
    }

    public override destroy(): void {
        this.container.destroy({ children: true });
    }

    public play(type: string, callback: () => void) {
        (this.container as RIPTypeTrigger).play(type, callback);
    }
}
